<div mat-dialog-content class="border-b">
  <p class="py-4">
    Are you sure you want to {{ data.archived ? 'unarchive' : 'archive' }} the quote #{{
      data.quoteId
    }}?
  </p>
</div>
<div mat-dialog-actions class="flex justify-end">
  <button mat-flat-button (click)="onCancel()" [disabled]="isDeleting()">NO</button>
  <button mat-flat-button (click)="onConfirm()" [disabled]="isDeleting()">YES</button>
</div>
